import { render, staticRenderFns } from "./AddQuick.vue?vue&type=template&id=f8ec6214&scoped=true&"
import script from "./AddQuick.vue?vue&type=script&lang=js&"
export * from "./AddQuick.vue?vue&type=script&lang=js&"
import style0 from "./AddQuick.vue?vue&type=style&index=0&id=f8ec6214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8ec6214",
  null
  
)

export default component.exports